<template>
	<div id="app">
		<component :is="layout">
			<router-view />
		</component>
	</div>
</template>

<script>
	import Layouts from '@/layouts/index.js'
	export default {
		name: 'App',
		components: {
			...Layouts
		},
		created() {
			this.$store.commit('system/GET_USER')
			this.$store.dispatch('dict_data/initData')
		},
		computed: {
			layout() {
				const {
					meta: {
						layout = 'DefaultLayout'
					}
				} = this.$route
				return layout
			}
		},
		metaInfo() {
			const link = [{
				rel: 'canonical',
				href: `${process.env.VUE_APP_DOMAIN}${this.$route.path}`
			}]
			if (!!this.$route.meta?.meta) {
				return {
					...this.$route.meta.meta,
					link
				}
			}
			return {
				title: '汲悟科技 - 科技助力跨境电商领域的Fintech公司',
				meta: [{
						name: 'description',
						content: '汲悟科技依托强大的数据能力、精准的风控模型和专业的行业经验，为跨境电商的金融领域提供智能化解决方案。'
					},
					{
						name: 'keywords',
						content: '汲悟科技,跨境电商,Fintech,数据对接,智能风控,风险管理,保险解决方案,科技赋能,金融服务,跨境保险'
					}
				],
				link
			}
		}
	}
</script>

<style>
</style>